import React from "react";
import {
  DirectionsBus,
  Flight,
  Train,
  LocalTaxi,
  DirectionsBoat,
  Commute
} from "@material-ui/icons";
import { makeStyles, Typography } from "@material-ui/core";
import { ToggleButtonGroup } from "@components/formx";
import { TransportationType } from "@bonliva-crm/shared";
import locale from "@bonliva-crm/locale";

export type TransportationTypeFieldProps = {
  name: string;
  exclusive?: boolean;
};

export function TransportationTypeField({
  name,
  exclusive = false
}: TransportationTypeFieldProps) {
  const classes = useStyles();

  return (
    <ToggleButtonGroup
      name={name}
      exclusive={exclusive}
      options={[
        {
          value: TransportationType.Train,
          label: (
            <div className={classes.root}>
              <Train />
              <Typography variant="caption">
                {locale.transportationType[TransportationType.Train]}
              </Typography>
            </div>
          )
        },
        {
          value: TransportationType.Flight,
          label: (
            <div className={classes.root}>
              <Flight />
              <Typography variant="caption">
                {locale.transportationType[TransportationType.Flight]}
              </Typography>
            </div>
          )
        },

        {
          value: TransportationType.Bus,
          label: (
            <div className={classes.root}>
              <DirectionsBus />
              <Typography variant="caption">
                {locale.transportationType[TransportationType.Bus]}
              </Typography>
            </div>
          )
        },

        {
          value: TransportationType.Boat,
          label: (
            <div className={classes.root}>
              <DirectionsBoat />
              <Typography variant="caption">
                {locale.transportationType[TransportationType.Boat]}
              </Typography>
            </div>
          )
        },

        {
          value: TransportationType.Taxi,
          label: (
            <div className={classes.root}>
              <LocalTaxi />
              <Typography variant="caption">
                {locale.transportationType[TransportationType.Taxi]}
              </Typography>
            </div>
          )
        },
        {
          value: TransportationType.Any,
          label: (
            <div className={classes.root}>
              <Commute />
              <Typography variant="caption">
                {locale.transportationType[TransportationType.Any]}
              </Typography>
            </div>
          )
        }
      ]}
      hideErrorLabel
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
}));
